/**
 * www sends learners here as ?course=<slug> when they click Enrol while signed
 * out. Signing in is only the detour — the destination is checkout, so paying
 * resumes exactly where they left off.
 *
 * Enrollment itself is never created from the browser: the API writes it only
 * after re-reading the charge from Moyasar.
 */
export function enrollDestination(slug: string | null) {
  return slug ? `/checkout?course=${encodeURIComponent(slug)}` : '/';
}
